import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReportingRegion } from "models/region-mapping";

export interface AdminRegionMappingSliceState {
    regions: ReportingRegion[];
    editingRegion: ReportingRegion | null;
}

export const initialState: AdminRegionMappingSliceState = {
    regions: [],
    editingRegion: null,
};

const byCode = (a: ReportingRegion, b: ReportingRegion) => a.code.localeCompare(b.code);

const AdminRegionMappingSlice = createSlice({
    name: "admin-region-mapping-slice",
    initialState,
    reducers: {
        setRegions(state, { payload }: PayloadAction<ReportingRegion[]>) {
            state.regions = [...payload].sort(byCode);
        },
        addRegion(state, { payload }: PayloadAction<ReportingRegion>) {
            state.regions = [...state.regions, payload].sort(byCode);
        },
        setRegion(state, { payload }: PayloadAction<ReportingRegion>) {
            const index = state.regions.findIndex(r => r.id === payload.id);
            if (index !== -1) state.regions[index] = payload;
            state.regions.sort(byCode);
        },
        removeRegion(state, { payload: id }: PayloadAction<string>) {
            state.regions = state.regions.filter(r => r.id !== id);
        },
        setEditingRegion(state, { payload }: PayloadAction<ReportingRegion | null>) {
            state.editingRegion = payload;
        },
    },
});

export const { setRegions, addRegion, setRegion, removeRegion, setEditingRegion } = AdminRegionMappingSlice.actions;

export default AdminRegionMappingSlice.reducer;
